import React, { Component } from 'react';
// import jQuery from 'jquery';
import AdminLayout from './layout';
import { getPaymentInfo } from '../../API/FetchCall';

const $ = require('jquery')

class paymentInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataSet: [],
            response:{}
        }
    }
    componentDidMount() {

         
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
      
    };  

    fetchPaymentDetail = (e) => {
        
    var ins = JSON.stringify({
            payment_id : this.state.payment_id

    })

     getPaymentInfo(ins).then((res) => {
        if (res.status == 1) {
            this.setState({response:res.results});
        } 
      });

    }


    UNSAFE_componentWillMount() {

    }
    componentDidUpdate() {
        window.jQuery('.selectpicker').selectpicker('refresh')
        // jQuery("#currency_selected").val(4);

    }

    render() {

        const {response} = this.state;

        return (
            
            <React.Fragment>
            <AdminLayout>
                <div class="col-lg-12 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                              <h4 class="card-title">Payment Transactions</h4>
                          
                              <div className="main-content col-md-12 col-xs-12">
                                <div className="box-shadow-custom">
                                     
                                        <div><input type="text" name="payment_id" class="inputcls" placeholder='Enter Payment ID' onChange={this.handleChange}/></div>
                                        <div class=""><button onClick={this.fetchPaymentDetail} class="btn btn-main">Fetch</button></div>

                                        <div id="info">
                                            <div>
                                                 <ul>
                                                     
                                                    <li>Amount : {response.amount}</li>
                                                    <li>Product : {response.description}</li>
                                                    <li>Payment ID : {response.id}</li>
                                                    <li>Card Id : {response.card_id}</li>
                                                    <li>Status: {response.status}</li>
                                                    <li>Contact: {response.contact}</li>
                                                    <li>Method: {response.method}</li>
                                                    <li>Created At: {response.created_at}</li>
                                                    <li>Currency: {response.currency}</li>
                                                    
                                                 </ul>
                                            </div>
                                        </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default paymentInfo;


// WEBPACK FOOTER //
// ./src/components/bewise/paymentInfo.jsx